import Seo from 'components/seo';
import PricingPolicy from 'containers/App/PricingPolicy';
import SiteLayout from 'layouts/SiteLayout';
import React from 'react';
import styled from 'styled-components';

const PlansBody = styled.div`
  section {
    padding-top: 48px;
    padding-bottom: 80px;
    background: #f7f7f9;
  }
`;

const PlansPage = () => (
  <SiteLayout>
    <Seo
      title="Plans | Furbuz Free and Furbuz Pro"
      description="Compare Furbuz Free and Furbuz Pro. Free covers care and Connect for up to two pets. Pro adds unlimited pets, no ads, and reports. Current prices are shown in the app."
    />
    <PlansBody>
      <PricingPolicy />
    </PlansBody>
  </SiteLayout>
);

export default PlansPage;
